import { StaticLayout } from './static-layout'

export function DocumentationPage() {
  return (
    <StaticLayout title="Documentation" description="Get the most out of mkdn.app.">
      <h2>Getting started</h2>
      <p>
        Hit <strong>New document</strong> from the home page. No sign-up required — start typing
        immediately. Your document gets a unique URL you can bookmark or share.
      </p>

      <h2>Markdown reference</h2>
      <pre>
        <code>{`# Heading 1
## Heading 2

**bold**, *italic*, ~~strikethrough~~

- bullet
- list

1. numbered
2. list

> blockquote

\`inline code\` and:

\`\`\`ts
const code = 'block'
\`\`\`

[Link](https://example.com)
![Image](https://example.com/img.png)

| Header | Header |
| --- | --- |
| Cell   | Cell   |`}</code>
      </pre>

      <h2>Real-time collaboration</h2>
      <p>
        Share the URL of your document with someone — they&apos;ll see your edits as you type, and
        you&apos;ll see theirs. Anonymous viewers get a temporary identity that persists for the
        document; signing in upgrades it to your real name.
      </p>

      <h2>Sharing</h2>
      <p>
        Click <strong>Share</strong>. Flip <em>Enable sharing</em> on and choose access level
        (read-only or can edit). Optionally enable <em>Presentation mode</em> for a clean,
        full-page view at <code>/p/&lt;document-id&gt;</code>.
      </p>

      <h2>Version history</h2>
      <p>
        Signed-in users can open the <strong>History</strong> dropdown to see saved versions and
        restore any of them.
      </p>

      <h2>Exporting</h2>
      <p>
        Use the <strong>Export</strong> dropdown to download as <code>.md</code> or
        <code>.html</code>.
      </p>

      <h2>Keyboard shortcuts</h2>
      <p>
        The editor uses the standard CodeMirror bindings. Common ones:
      </p>
      <ul>
        <li><kbd>Cmd/Ctrl</kbd> + <kbd>Z</kbd> — undo</li>
        <li><kbd>Cmd/Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>Z</kbd> — redo</li>
        <li><kbd>Cmd/Ctrl</kbd> + <kbd>F</kbd> — find</li>
      </ul>
    </StaticLayout>
  )
}
